export { GlossaryTerm, glossaryTermSchema } from './glossary-term';
